<template>
  <div v-if="show" class="profile-modal-overlay">
    <div class="profile-modal large">
      <h2>Atualize seu Perfil Profissional</h2>
      <form @submit.prevent="submit">
        <div class="form-group">
          <label>Perfil</label>
          <div class="profile-cards-scroll">
            <div
              v-for="group in expertiseGroups"
              :key="group.title"
              class="profile-card large"
              :class="{ selected: modalProfile === group.title }"
              @click="selectProfile(group.title)"
            >
              <img :src="group.image" :alt="'Foto de perfil para ' + group.title" />
              <div class="profile-card-footer">
                <span class="profile-label">{{ group.title }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group" v-if="modalProfile">
          <label>Foco</label>
          <div class="focus-chips">
            <button
              v-for="sub in currentSubgroups"
              :key="sub"
              type="button"
              :class="['focus-chip', { selected: modalFocus === sub }]"
              @click="modalFocus = sub"
            >
              {{ sub }}
            </button>
          </div>
        </div>
        <div class="form-group">
          <label for="availability">Disponibilidade semanal (horas)</label>
          <input id="availability" type="number" min="1" v-model.number="modalAvailability" required placeholder="Ex: 20" />
        </div>
        <div class="form-group">
          <label for="sinceYear">Desde que ano atua como {{ modalProfile && modalFocus ? modalProfile + ' / ' + modalFocus : '' }}</label>
          <input id="sinceYear" type="number" min="1970" :max="currentYear" v-model.number="modalSinceYear" required placeholder="Ex: 2018" />
        </div>
        <div class="form-group">
          <label for="hourRate">Valor-hora (R$)</label>
          <input
            id="hourRate"
            type="number"
            min="1"
            :max="!isVibbrante ? maxHourRate : null"
            v-model.number="modalHourRate"
            required
            :placeholder="!isVibbrante && maxHourRate ? 'Máximo: R$ ' + maxHourRate : 'Ex: 100'"
          />
          <small v-if="!isVibbrante && modalHourRate && maxHourRate && modalHourRate > maxHourRate" class="error">Valor-hora não pode exceder R$ {{ maxHourRate }}</small>
          <small v-if="!isVibbrante && maxHourRate" class="info">Valor máximo para este perfil: R$ {{ maxHourRate }}</small>
        </div>
        <div class="modal-actions">
          <button type="submit" :disabled="!canSubmit">Salvar</button>
          <button type="button" @click="$emit('close')">Fechar</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProfileModal',
  props: {
    show: { type: Boolean, default: false },
    vibbranteData: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      expertiseGroups: [
        {
           title: "Desenvolvedor",
          image: require('@/assets/photoPeople/Lucas.png'),
          subgroups: ["Full-stack Developer", "Back-end Developer", "Front-end Developer", "Mobile Developer"],
        },
        {
          title: "Infraestrutura e DevOps",
          image: require('@/assets/photoPeople/Planos-Enterprise.png'),
          subgroups: ["DevOps Engineer", "Cloud Engineer", "Systems Engineer", "Infrastructure Specialist"],
        },
        {
          title: "Liderança Técnica e Gestão",
          image: require('@/assets/photoPeople/Sarah-designer.png'),
          subgroups: ["Engineering Manager", "Tech Lead", "Software Architect"],
        },
        {
          title: "Dados e Inteligência Artificial",
          image: require('@/assets/photoPeople/maria-verde.png'),
          subgroups: ["Data Scientist", "Machine Learning Engineer", "AI Ethics and Governance Specialist", "Robotics and Automation Engineer", "Data Engineer"],
        },
        {
          title: "Analista",
          image: require('@/assets/photoPeople/Lucas 2.png'),
          subgroups: ["Business Analyst", "QA Analyst", "BI Analyst", "Project Analyst", "Data Analyst"],
        },
        {
          title: "Designer",
          image: require('@/assets/photoPeople/Sarah-designer 2.png'),
          subgroups: ["UI Designer", "UX Designer", "Product Designer (UI/UX)", "Branding Specialist"],
        },
      ],
      modalProfile: '',
      modalFocus: '',
      modalAvailability: '',
      modalSinceYear: '',
      modalHourRate: '',
      currentYear: new Date().getFullYear(),
    }
  },
  watch: {
    show(newVal) {
      console.log('ProfileModal show watcher:', {
        newVal,
        hasVibbranteData: !!this.vibbranteData,
        vibbranteData: this.vibbranteData
      });

      if (newVal) {
        this.loadVibbranteData();
      }
    },
    vibbranteData: {
      handler(newVal) {
        console.log('ProfileModal vibbranteData watcher:', {
          newVal,
          show: this.show
        });
        if (this.show && newVal) {
          this.loadVibbranteData();
        }
      },
      deep: true,
      immediate: false
    },
    modalSinceYear(newVal, oldVal) {
      console.log('modalSinceYear watcher:', {
        newVal,
        oldVal,
        isVibbrante: this.isVibbrante,
        modalProfile: this.modalProfile
      });
      // Só recalcula se houve mudança real do usuário (não na carga inicial)
      if (this.modalProfile && newVal && oldVal !== undefined && oldVal !== '') {
        this.$nextTick(() => {
          // Para vibbrantes, auto-preenche com um valor sugerido
          // Para não-vibbrantes, apenas recalcula o limite máximo
          if (this.isVibbrante) {
            // Pode adicionar lógica de sugestão aqui se desejar
          }
        });
      }
    },
    modalFocus(newVal, oldVal) {
      console.log('modalFocus watcher:', {
        newVal,
        oldVal,
        isVibbrante: this.isVibbrante,
        modalProfile: this.modalProfile
      });
      // Só recalcula se houve mudança real do usuário (não na carga inicial)
      if (this.modalProfile && newVal && oldVal !== undefined && oldVal !== '') {
        this.$nextTick(() => {
          // Para vibbrantes, atualizar o valor-hora automaticamente se o novo valor calculado for maior
          if (this.isVibbrante && this.modalSinceYear) {
            const calculatedMaxValue = this.calculateMaxHourRateValue();
            console.log('Focus mudou - Valor calculado para vibbrante:', {
              calculatedMaxValue,
              currentModalHourRate: this.modalHourRate
            });
            
            if (calculatedMaxValue && (!this.modalHourRate || calculatedMaxValue > this.modalHourRate)) {
              this.modalHourRate = calculatedMaxValue;
              console.log('Valor-hora atualizado via focus para:', calculatedMaxValue);
            }
          }
        });
      }
    }
  },
  computed: {
    currentSubgroups() {
      const group = this.expertiseGroups.find(g => g.title === this.modalProfile);
      return group ? group.subgroups : [];
    },
    yearsExperience() {
      if (!this.modalSinceYear || this.modalSinceYear > this.currentYear) {
        return null;
      }
      return this.currentYear - this.modalSinceYear;
    },
    maxHourRate() {
      const value = this.calculateMaxHourRate();
      console.log('maxHourRate computed:', {
        value,
        profile: this.modalProfile,
        focus: this.modalFocus,
        yearsExp: this.yearsExperience,
        isVibbrante: this.isVibbrante
      });
      return value;
    },
    canSubmit() {
      return (
        this.modalProfile &&
        this.modalFocus &&
        this.modalAvailability &&
        this.modalSinceYear &&
        this.modalHourRate &&
        (this.isVibbrante || !this.maxHourRate || this.modalHourRate <= this.maxHourRate)
      );
    },
    isVibbrante() {
      return this.vibbranteData && this.vibbranteData.vibbrante_type === 'vibbrante';
    },
    isHourRateEditable() {
      return this.vibbranteData && this.vibbranteData.vibbrante_type === 'vibbrante';
    }
  },
  methods: {
    loadVibbranteData() {
      // Carregar dados existentes quando a modal for aberta
      // Usar os campos corretos do backend: profile, focus, years_experience, real_hour_value, hour_available
      if (this.vibbranteData && Object.keys(this.vibbranteData).length > 0) {
        this.modalProfile = this.vibbranteData.profile || '';
        this.modalFocus = this.vibbranteData.focus || '';
        this.modalAvailability = this.vibbranteData.hour_available || '';

        // Calcular o ano baseado em years_experience
        if (this.vibbranteData.years_experience) {
          this.modalSinceYear = this.currentYear - this.vibbranteData.years_experience;
        } else {
          this.modalSinceYear = '';
        }

        // Sempre carregar o valor-hora existente se houver
        this.modalHourRate = this.vibbranteData.real_hour_value || '';

        console.log('Dados carregados na modal:', {
          modalProfile: this.modalProfile,
          modalFocus: this.modalFocus,
          modalAvailability: this.modalAvailability,
          modalSinceYear: this.modalSinceYear,
          modalHourRate: this.modalHourRate
        });
      }
    },
    calculateMaxHourRate() {
      console.log('calculateMaxHourRate chamado:', {
        isVibbrante: this.isVibbrante,
        profile: this.modalProfile,
        yearsExp: this.yearsExperience
      });

      if (!this.modalProfile) {
        console.log('Sem perfil, retornando vazio');
        return '';
      }

      let maxValue = 0;
      const profile = this.modalProfile;
      const yearsExp = this.yearsExperience;


        if (yearsExp === null) {
          // Sem experiência ou ano inválido
          switch(profile) {
            case "Desenvolvedor":
              maxValue = 70.0;
              break;
            case "Infraestrutura e DevOps":
              maxValue = 60.0;
              break;
            case "Liderança Técnica e Gestão":
              maxValue = 85.0;
              break;
            case "Dados e Inteligência Artificial":
              maxValue = 80.0;
              break;
            case "Analista":
              maxValue = 50.0;
              break;
            case "Designer":
              maxValue = 50.0;
              break;
            default:
              maxValue = 45.0;
          }
        } else if (yearsExp < 6) {
          // Menos de 6 anos de experiência
          switch(profile) {
            case "Desenvolvedor":
              maxValue = 70.0;
              break;
            case "Infraestrutura e DevOps":
              maxValue = 70.0;
              break;
            case "Liderança Técnica e Gestão":
              maxValue = 85.0;
              break;
            case "Dados e Inteligência Artificial":
              maxValue = 100.0;
              break;
            case "Analista":
              maxValue = 50.0;
              break;
            case "Designer":
              maxValue = 50.0;
              break;
            default:
              maxValue = 45.0;
          }
        } else if (yearsExp >= 6 && yearsExp < 10) {
          // Entre 6 e 9 anos de experiência
          switch(profile) {
            case "Desenvolvedor":
              maxValue = 85.0;
              break;
            case "Infraestrutura e DevOps":
              maxValue = 80.0;
              break;
            case "Liderança Técnica e Gestão":
              maxValue = 100.0;
              break;
            case "Dados e Inteligência Artificial":
              maxValue = 115.0;
              break;
            case "Analista":
              maxValue = 65.0;
              break;
            case "Designer":
              maxValue = 75.0;
              break;
            default:
              maxValue = 45.0;
          }
        } else { // yearsExp >= 10
          // 10 ou mais anos de experiência
          switch(profile) {
            case "Desenvolvedor":
              maxValue = 100.0;
              break;
            case "Infraestrutura e DevOps":
              maxValue = 85.0;
              break;
            case "Liderança Técnica e Gestão":
              maxValue = 110.0;
              break;
            case "Dados e Inteligência Artificial":
              maxValue = 130.0;
              break;
            case "Analista":
              maxValue = 80.0;
              break;
            case "Designer":
              maxValue = 90.0;
              break;
            default:
              maxValue = 45.0;
          }
        }

      if(this.vibbranteData && this.vibbranteData.vibbrante_type === 'vibbrante') {
        // Para vibbrantes, verificar se maxValue > real_hour_value, se não, atribuir maxValue = real_hour_value
        const currentHourValue = this.vibbranteData.real_hour_value;
        console.log('Verificando valor para vibbrante:', {
          maxValue,
          currentHourValue,
          shouldUpdate: currentHourValue && maxValue < currentHourValue
        });
        if (currentHourValue && maxValue < currentHourValue) {
          maxValue = currentHourValue;
        }
      }

      console.log('Retornando maxValue:', maxValue);
      
      // Para vibbrantes, retornar vazio como limitador (não há limite)
      // Mas a função ainda calcula o valor para uso interno
      if (this.isVibbrante) {
        console.log('É vibbrante, retornando vazio como limitador');
        return '';
      }
      
      return maxValue || '';
    },
    calculateMaxHourRateValue() {
      // Função auxiliar que sempre calcula o valor, mesmo para vibbrantes
      if (!this.modalProfile) {
        return 0;
      }

      let maxValue = 0;
      const profile = this.modalProfile;
      const yearsExp = this.yearsExperience;

      if (yearsExp === null) {
        // Sem experiência ou ano inválido
        switch(profile) {
          case "Desenvolvedor":
            maxValue = 70.0;
            break;
          case "Infraestrutura e DevOps":
            maxValue = 60.0;
            break;
          case "Liderança Técnica e Gestão":
            maxValue = 85.0;
            break;
          case "Dados e Inteligência Artificial":
            maxValue = 80.0;
            break;
          case "Analista":
            maxValue = 50.0;
            break;
          case "Designer":
            maxValue = 50.0;
            break;
          default:
            maxValue = 45.0;
        }
      } else if (yearsExp < 6) {
        // Menos de 6 anos de experiência
        switch(profile) {
          case "Desenvolvedor":
            maxValue = 70.0;
            break;
          case "Infraestrutura e DevOps":
            maxValue = 70.0;
            break;
          case "Liderança Técnica e Gestão":
            maxValue = 85.0;
            break;
          case "Dados e Inteligência Artificial":
            maxValue = 100.0;
            break;
          case "Analista":
            maxValue = 50.0;
            break;
          case "Designer":
            maxValue = 50.0;
            break;
          default:
            maxValue = 45.0;
        }
      } else if (yearsExp >= 6 && yearsExp < 10) {
        // Entre 6 e 9 anos de experiência
        switch(profile) {
          case "Desenvolvedor":
            maxValue = 85.0;
            break;
          case "Infraestrutura e DevOps":
            maxValue = 80.0;
            break;
          case "Liderança Técnica e Gestão":
            maxValue = 100.0;
            break;
          case "Dados e Inteligência Artificial":
            maxValue = 115.0;
            break;
          case "Analista":
            maxValue = 65.0;
            break;
          case "Designer":
            maxValue = 75.0;
            break;
          default:
            maxValue = 45.0;
        }
      } else { // yearsExp >= 10
        // 10 ou mais anos de experiência
        switch(profile) {
          case "Desenvolvedor":
            maxValue = 100.0;
            break;
          case "Infraestrutura e DevOps":
            maxValue = 85.0;
            break;
          case "Liderança Técnica e Gestão":
            maxValue = 110.0;
            break;
          case "Dados e Inteligência Artificial":
            maxValue = 130.0;
            break;
          case "Analista":
            maxValue = 80.0;
            break;
          case "Designer":
            maxValue = 90.0;
            break;
          default:
            maxValue = 45.0;
        }
      }

      if(this.vibbranteData && this.vibbranteData.vibbrante_type === 'vibbrante') {
        // Para vibbrantes, verificar se maxValue > real_hour_value, se não, atribuir maxValue = real_hour_value
        const currentHourValue = this.vibbranteData.real_hour_value;
        if (currentHourValue && maxValue < currentHourValue) {
          maxValue = currentHourValue;
        }
      }

      return maxValue;
    },
    selectProfile(title) {
      this.modalProfile = title;
      this.modalFocus = '';

      // Espera até o próximo ciclo para garantir que modalProfile esteja atualizado
      this.$nextTick(() => {
        console.log('selectProfile debug:', {
          profile: this.modalProfile,
          isVibbrante: this.isVibbrante,
          yearsExperience: this.yearsExperience,
          modalSinceYear: this.modalSinceYear
        });
        
        // Para vibbrantes, atualizar o valor-hora automaticamente se o novo valor calculado for maior
        if (this.isVibbrante && this.modalSinceYear) {
          const calculatedMaxValue = this.calculateMaxHourRateValue();
          console.log('Valor calculado para vibbrante:', {
            calculatedMaxValue,
            currentModalHourRate: this.modalHourRate
          });
          
          if (calculatedMaxValue && (!this.modalHourRate || calculatedMaxValue > this.modalHourRate)) {
            this.modalHourRate = calculatedMaxValue;
            console.log('Valor-hora atualizado para:', calculatedMaxValue);
          }
        }
      });
    },
    submit() {
      if (!this.canSubmit) return;
      console.log('Salvando dados da modal:', {
        profile: this.modalProfile,
        focus: this.modalFocus,
        availability: this.modalAvailability,
        sinceYear: this.modalSinceYear,
        hourRate: this.modalHourRate
      });
      // Emit all modal data to parent
      this.$emit('save', {
        profile: this.modalProfile,
        focus: this.modalFocus,
        availability: this.modalAvailability,
        sinceYear: this.modalSinceYear,
        hourRate: this.modalHourRate
      });
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.profile-cards-scroll {
  display: flex;
  overflow-x: auto;
  gap: 24px;
  padding: 8px 18px 18px 18px;
  margin-bottom: 16px;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-x;
  overscroll-behavior-x: contain;
}
.profile-cards-scroll::-webkit-scrollbar {
  height: 8px;
}
.profile-cards-scroll::-webkit-scrollbar-thumb {
  background: #e3e8f0;
  border-radius: 4px;
}
.profile-card {
  min-width: 230px;
  max-width: 260px;
  background: #f7f7fa;
  border-radius: 20px;
  box-shadow: 0 2px 14px rgba(0,0,0,0.13);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  cursor: pointer;
  border: 2px solid transparent;
  transition: border-color 0.18s, box-shadow 0.18s;
  margin-bottom: 4px;
}
.profile-card.large {
  min-width: 260px;
  max-width: 310px;
}
.profile-card.selected {
  border-color: #0a7cff;
  box-shadow: 0 4px 18px rgba(10,124,255,0.13);
}
.profile-card img {
  width: 100%;
  height: 180px;
  object-fit: cover;
  object-position: center top;
  border-top-left-radius: 18px;
  border-top-right-radius: 18px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  margin-bottom: 0;
  display: block;
  background: #e9ecef;
}
.profile-card-footer {
  width: 100%;
  background: #0a7cff;
  border-bottom-left-radius: 14px;
  border-bottom-right-radius: 14px;
  padding: 15px 0 12px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.profile-label {
  color: #fff;
  font-size: 1.13rem;
  font-weight: 600;
  text-align: center;
  letter-spacing: 0.01em;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.8em;
  min-height: 2.8em;
  max-height: 2.8em;
  line-height: 1.3em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-word;
  padding: 0 6px;
}

.focus-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;
}
.focus-chip {
  background: #f0f4fa;
  color: #1b2433;
  border: 2px solid transparent;
  border-radius: 16px;
  padding: 7px 16px;
  font-size: 0.98rem;
  cursor: pointer;
  outline: none;
  transition: all 0.18s;
}
.focus-chip.selected {
  background: #0a7cff;
  color: #fff;
  border: 2px solid #0a7cff;
  outline: 3px solid rgba(10, 124, 255, 0.3);
  outline-offset: 2px;
}
.profile-modal-overlay {
  position: fixed;
  top: 0; left: 0; width: 100vw; height: 100vh;
  background: rgba(0,0,0,0.7);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.3s;
}
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
.profile-modal {
  background: #fff;
  border-radius: 16px;
  padding: 40px 38px 28px 38px;
  max-width: 1820px;
  width: 1820px;
  box-shadow: 0 8px 40px rgba(0,0,0,0.20);
  text-align: left;
}
.profile-modal.large {
  max-width: 90vw;
  padding: 48px 48px 32px 48px;
}
@media (max-width: 768px) {
  .profile-modal.large {
    padding: 20px 16px;
  }
}

.profile-modal h2 {
  font-size: 1.45rem;
  margin-bottom: 18px;
  text-align: center;
}
.profile-modal .form-group {
  margin-bottom: 16px;
}
.profile-modal label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
}
.profile-modal select,
.profile-modal input[type="number"] {
  width: 100%;
  padding: 7px 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 1rem;
}
.profile-modal .modal-actions {
  margin-top: 22px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.profile-modal button[type="submit"] {
  background: #0a7cff;
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 8px 18px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.18s;
}
.profile-modal button[type="submit"]:disabled {
  background: #b3d6f7;
  cursor: not-allowed;
}
.profile-modal button[type="button"] {
  background: #eee;
  color: #333;
  border: none;
  border-radius: 5px;
  padding: 8px 18px;
  font-size: 1rem;
  cursor: pointer;
}
.profile-modal .error {
  color: #c00;
  font-size: 0.92rem;
  margin-top: 3px;
  display: block;
}
.profile-modal .info {
  color: #666;
  font-size: 0.92rem;
  margin-top: 3px;
  display: block;
}
.profile-modal input:disabled {
  background-color: #f5f5f5;
  color: #999;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/parts/components/profile-modal.vue